import { Alert, Button, Chip, Stack, Typography } from "@mui/material";
import { Labeled } from "react-admin";
import { z } from "zod";
import { schemas } from "../../api/server.api";

type ExternalTrainingProgress = z.infer<typeof schemas.ExternalTrainingProgressDto>;

export function ExternalTrainingProgressField(props: {
  progress?: ExternalTrainingProgress[];
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  onEdit: (progress: ExternalTrainingProgress) => void;
}) {
  const { progress, isLoading, isError, onRetry, onEdit } = props;
  if (!isLoading && !isError && !progress?.length) return null;

  return (
    <Labeled label="Externer Ausbildungsstand">
      <Stack direction="row" gap={0.5} flexWrap="wrap" alignItems="flex-start">
        {isError ? (
          <Alert severity="error" action={<Button onClick={onRetry}>Erneut laden</Button>}>
            Der externe Ausbildungsstand konnte nicht geladen werden.
          </Alert>
        ) : isLoading ? (
          <Typography color="text.secondary">Wird geladen…</Typography>
        ) : (
          progress?.map((item) => (
            <Chip
              key={item.drivingLicenseClass}
              size="small"
              label={item.drivingLicenseClass}
              onClick={() => onEdit(item)}
              aria-label={`Ausbildungsstand Klasse ${item.drivingLicenseClass} bearbeiten`}
            />
          ))
        )}
      </Stack>
    </Labeled>
  );
}
